export enum InformationKey {
  Avtal = 'Avtal',
  AvtalFAQ = 'Avtal FAQ',
  AvtalstillvalFAQFJV = 'Avtalstillval FAQ - FJV',
  AvtalstillvalFAQFJK = 'Avtalstillval FAQ - FJK',
  MeteringpointInfoGeneric = 'Intelligykunder',
  MeteringpointInfoIntelligy = 'Ej intelligykunder',
  ServicesIntelligy = 'Tjänstsida - Intelligy'
}
